import Gateway from './gateway';
import { GatewayResponse } from '~types/gateway';

import { TCreateNewProjectAPIParams, TEditProjectDetailsAPIParams, TGetProjectDetailsAPIParams, TGetProjectFilterAPIParams, TGetProjectFilterAPIResponse, TGetProjectListingAPIParams, TGetProjectListingAPIResponse, TProjectDetails } from '~types/feat/project';
import { TGetPendingProjectListingReduxResponse, TGetProjectChangeHistoryAPIParams } from '~types/feat/setting';

export abstract class IProjectGateway extends Gateway {
    abstract getProjectListing(params: TGetProjectListingAPIParams): GatewayResponse<TGetProjectListingAPIResponse>;

    abstract createNewProject(params: TCreateNewProjectAPIParams): GatewayResponse<null>;

    abstract getProjectDetails(params: TGetProjectDetailsAPIParams): GatewayResponse<TProjectDetails>;

    abstract editProjectDetails(params: TEditProjectDetailsAPIParams): GatewayResponse<null>;

    abstract getProjectChangeHistoryListing(params: TGetProjectChangeHistoryAPIParams): GatewayResponse<TGetPendingProjectListingReduxResponse>;

    abstract getProjectFilters(params: TGetProjectFilterAPIParams): GatewayResponse<TGetProjectFilterAPIResponse>;

}
